import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from "universal-cookie";
import { REDIRECT_URL, SERVICE_KEY, TOKEN_NAME } from "./config";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const cookies = new Cookies();
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

if (checkAuth()) {
  root.render(
    // <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
    // </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

function checkAuth() {
  const token = cookies.get(TOKEN_NAME);

  if (!token) {
    window.location.href = `${REDIRECT_URL}?pid=${SERVICE_KEY}`;
    return false;
  } else {
    return true;
  }
}
